const initialState = {
    isOpen: false,
};

const sidebarReducer = (state = initialState, action) => {
    switch (action.type) {
        case "TOGGLE_DRAWER":
            return {
                ...state,
                isOpen: !state.isOpen
            }
        case "LOGOUT":
            return initialState;
        default:
            return state;
    }
};

export default sidebarReducer;
